import Buzzer from './buzzer';

export default Buzzer;
